import React from 'react';
import * as cls from './subscribe.module.css';
import { Typography } from '../typography';

export const Subscribe = () => {
  const feedbackRef = React.useRef(null);
  const formRef = React.useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    const email = event.target.elements.email;
    feedbackRef.current.classList.remove(cls.error);
    feedbackRef.current.textContent = '';

    if (
      !email.value.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
    ) {
      email.classList.add(cls.error);
      return;
    }

    formRef.current.querySelector('fieldset').disabled = true;
    email.classList.remove(cls.error);

    fetch('/.netlify/functions/mailerlite-subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: email.value }),
    })
      .then((res) => {
        if (res.ok) {
          email.value = '';
          feedbackRef.current.textContent = 'Thank you for subscribing!';
        } else {
          feedbackRef.current.classList.add(cls.error);
          feedbackRef.current.textContent =
            'An error occurred while subscribing.';
        }
      })
      .catch(() => {
        feedbackRef.current.classList.add(cls.error);
        feedbackRef.current.textContent =
          'An error occurred while subscribing.';
      })
      .finally(() => {
        formRef.current.querySelector('fieldset').disabled = false;
      });
  };

  return (
    <div className={cls.wrapper}>
      <Typography tag="h2">
        <b>Subscribe to Our News and Updates!</b>
      </Typography>
      <Typography className={cls.feedback} ref={feedbackRef}></Typography>
      <form onSubmit={handleSubmit} ref={formRef}>
        <fieldset className={cls.form}>
          <input
            autoComplete="email"
            name="email"
            placeholder="Email"
            type="email"
          />
          <button type="submit">Subscribe</button>
        </fieldset>
      </form>
      <Typography className={cls.links}>
        By clicking Subscribe, you agree to our{' '}
        <a href="/terms-and-conditions">Terms of Use</a> and{' '}
        <a href="/privacy-policy">Privacy Policy</a>.
      </Typography>
    </div>
  );
};
